import * as types from '../mutation-types'

export const USER_KEY = 'user.inext'

// const cachedUser = JSON.parse(localStorage.getItem(USER_KEY)) || {}

// initial state
const state = {
  id: null,
  jwt: null,
  name: null,
  email: null,
  avatar: null,
  authStatus: null,
  authError: null,
}

// getters
const getters = {
  user: state => {
    return {
      id: state.id,
      iwt: state.iwt,
      name: state.name,
      email: state.email,
      avatar: state.avatar
    }
  },
  isUserLoggedIn: state => {
    if (state.jwt && state.id) {
      return true
    }
    return false
  },
  authStatus: state => state.authStatus,
  authError: state => state.authError,
}

// mutations
const mutations = {

  [types.UPDATE_USER_JWT] (state, jwt) {
    state.jwt = jwt
  },

  [types.UPDATE_USER] (state, user) {
    state.id = user.id
    state.name = user.name
    state.email = user.email
    state.avatar = user.avatar
  },

  [types.LOGOUT_USER] (state) {
    state.id = null
    state.jwt = null
    state.name = null
    state.email = null
    state.avatar = null
  },

  [types.AUTH_REQUEST] (state) {
    state.authError = null
    state.authStatus = null
  },

  [types.AUTH_SUCCESS] (state) {
    state.authError = null
    state.authStatus = 'successful'
  },

  [types.AUTH_FAILURE] (state, error) {
    state.authError = error
    state.authStatus = 'failed'
  },

}

export default {
  state,
  getters,
  mutations
}
